module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8ea9506","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/auth.vue
// module id = 504
// module chunks = 1